import React, { useState } from "react";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import AsynchronousAutocomplete from "../../components/Autocomplete/AsynchronousAutocomplete";
import { DialogContent, Grid, IconButton, Typography } from "@mui/material";
import Close from "@mui/icons-material/Close";
import { useDialog } from "../../licensing/utils/DialogProvider";
import { _patch } from "../../http";
import Button from "../../components/CustomButtons/Button";

function AddSalesAreasToOtherUserDialog(props) {
  const [salesAreas, setSalesAreas] = useState(null);
  const [value, setValue] = useState((props.salesareaIds ?? "").replace(/\s/g, "")); // Remove all spaces
  const [user, setUser] = useState(null);
  const [, closeDialog] = useDialog();

  return (
    <>
      <DialogContent
        style={{
          display: "flex",
          paddingRight: 0,
          paddingTop: 0,
          justifyContent: "space-between",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <Typography style={{ fontSize: "1.3rem", fontWeight: 800 }} variant={"body1"}>
          <TranslationWrapper tKey={"Add sales areas to other user"} />
        </Typography>
        <IconButton onClick={() => closeDialog()}>
          <Close />
        </IconButton>
      </DialogContent>
      <DialogContent>
        <Grid container spacing={3} style={{ marginTop: 0, marginBottom: 0 }}>
          <Grid item xs={12}>
            <AsynchronousAutocomplete
              async={{
                url: "core/vestigingen/search?fields=id as value, systeemNaam as label",
                searchField: "systeemNaam",
                perPage: 50,
              }}
              multiple={true}
              onChange={(e, value) => {
                setSalesAreas(value);
                value = value.map((salesarea) => salesarea.value).join(",");
                setValue(value);
              }}
              placeholder={getTranslation(
                "gebruikers.form.vestigingen.taglist.menuFood.headerText",
                "Select a sales area"
              )}
              value={
                salesAreas ??
                value
                  ?.split(",")
                  .filter((id) => id.length > 0)
                  .map((id) => ({ value: Number(id) }))
              }
            />
          </Grid>
          <Grid item xs={12}>
            <AsynchronousAutocomplete
              async={{
                url: "core/gebruikers/search?fields=id as value, email as label,salesAreas",
                searchField: "email",
                perPage: 50,
              }}
              onChange={(e, value) => {
                let userSalesAreas = value.salesAreas?.split(",") ?? [];
                if (salesAreas) {
                  userSalesAreas = userSalesAreas.concat(salesAreas);
                }
                setSalesAreas(userSalesAreas);
                setUser(value);
              }}
              placeholder={getTranslation("Pick a user")}
              value={user}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              color={"success"}
              disabled={user == null}
              onClick={() => {
                _patch(`core/gebruikers/${user.value}`, { salesAreas: value }).then(() => closeDialog());
              }}
            >
              <TranslationWrapper tDefault={"Opslaan"} tKey={"global.jamezzForm.savebutton.text"} />
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </>
  );
}

export default AddSalesAreasToOtherUserDialog;
